import React from 'react';


const AboutUs = () => {
    const cards = [
        {
            image: "./road_construction.png",
            title: "Road Construction",
            description: (
                <div className="text-left space-y-2">  {/* Changed from ul to div */}
                    <div className="flex items-center animate-fadeIn" style={{animationDelay: '0.2s'}}>
                        ➜ Rural & Urban Road Networks
                    </div>
                    <div className="flex items-center animate-fadeIn" style={{animationDelay: '0.4s'}}>
                        ➜ Highway Rehabilitation & Expansion
                    </div>
                    <div className="flex items-center animate-fadeIn" style={{animationDelay: '0.6s'}}>
                        ➜ Drainage & Utility Systems
                    </div>
                </div>
            )
        },
        {
            image: "./project_management.jpg",
            title: "Project Management",
            description: (
                <div className="text-left space-y-2">  {/* Changed from ul to div */}
                    <div className="flex items-center animate-fadeIn" style={{animationDelay: '0.2s'}}>
                        ➜ Land Acquisition & Permitting
                    </div>
                    <div className="flex items-center animate-fadeIn" style={{animationDelay: '0.4s'}}>
                        ➜ Architecture & Engineering Design
                    </div>
                    <div className="flex items-center animate-fadeIn" style={{animationDelay: '0.6s'}}>
                        ➜ Project Supervision & Completion
                    </div>
                    <div className="flex items-center animate-fadeIn" style={{animationDelay: '0.8s'}}>
                        ➜ Quality Control & Reporting Systems 
                    </div>
                </div>
            )
        },
        {
            image: "./airport_construction.jpg",
            title: "Construction & Real Estate",
            description: (
                <div className="text-left space-y-2">  {/* Changed from ul to div */}
                    <div className="flex items-center animate-fadeIn" style={{animationDelay: '0.2s'}}>
                        ➜ Residential & Commercial Developments
                    </div>
                    <div className="flex items-center animate-fadeIn" style={{animationDelay: '0.4s'}}>
                        ➜ Educational and Healthcare Facilities
                    </div>
                    <div className="flex items-center animate-fadeIn" style={{animationDelay: '0.6s'}}>
                        ➜ Industrial Buildings
                    </div>
                    <div className="flex items-center animate-fadeIn" style={{animationDelay: '0.8s'}}>
                        ➜ Leisure & Hospitality Infrasturcture
                    </div>
                </div>
            )
        },
        {
            image: "./general_supplies.jpg",
            title: "General Supplies",
            description: (
                <div className="text-left space-y-2">  {/* Changed from ul to div */}
                    <div className="flex items-center animate-fadeIn" style={{animationDelay: '0.2s'}}>
                        ➜ Nationwide procurement and delivery of building materials
                    </div>
                    <div className="flex items-center animate-fadeIn" style={{animationDelay: '0.4s'}}>
                        ➜ Sanitary wares, tiles, doors and fittings(produced in-house)
                    </div>
                    <div className="flex items-center animate-fadeIn" style={{animationDelay: '0.6s'}}>
                        ➜ Supply contact with government and private sector clients
                    </div>
                </div>
            )
        }
    ];

    const getRandomTilt = () => Math.random() * 6 - 3;

    return (
        <div id="about" className="flex flex-col items-center mt-6 pt-20">
            <div className="flex flex-col items-center mb-8 mt-10 text-center">
                <p className="text-3xl font-semibold mb-2">
                    We offer <span className="font-bold italic relative after:content-[''] after:absolute after:bottom-1 after:left-0 after:w-full after:h-[3px] after:bg-current after:[clip-path:polygon(0_45%,5%_44%,10%_43%,15%_45%,20%_47%,25%_45%,30%_43%,35%_41%,40%_43%,45%_45%,50%_47%,55%_45%,60%_43%,65%_45%,70%_47%,75%_45%,80%_43%,85%_45%,90%_47%,95%_45%,100%_43%)]">turnkey solutions</span> across residential,
                </p>
                <p className="text-3xl font-semibold">
                    commercial, industrial and public infrastructure sectors
                </p>
            </div>
            {/* Desktop view */}
                        <div className="hidden lg:flex justify-center items-center flex-wrap p-16">
                            {cards.map((card, index) => (
                                <div 
                                    key={index} 
                                    className="w-[280px] h-[380px] [perspective:1000px] ml-8 first:ml-0 hover:z-10 relative"
                                    style={{ transform: `rotate(${getRandomTilt()}deg)` }}
                                >
                                    <div className="relative w-full h-[80%] transition-all duration-500 [transform-style:preserve-3d] hover:[transform:rotateY(180deg)]">
                                        <div className="absolute w-full h-full rounded-2xl shadow-lg overflow-hidden [backface-visibility:hidden]">
                                            <img 
                                                src={card.image} 
                                                alt={card.title} 
                                                className="w-full h-full object-cover"
                                            />
                                            <div className="absolute bottom-0 w-full bg-black bg-opacity-30 text-white p-4">
                                                <h2 className="text-xl font-bold">{card.title}</h2>
                                            </div>
                                        </div>
                                        <div className="absolute w-full h-full rounded-2xl shadow-lg bg-[#1e2b2f] p-5 flex flex-col justify-center items-center text-center text-gray-50 [backface-visibility:hidden] [transform:rotateY(180deg)] [background-image:repeating-linear-gradient(45deg,rgba(255,255,255,0.1)_0px,rgba(255,255,255,0.1)_2px,transparent_2px,transparent_4px)]">
                                            <h2 className="text-2xl font-bold mb-4">{card.title}</h2>
                                            <div className="text-gray-100">{card.description}</div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {/* Mobile/Tablet carousel */}
            <div className="lg:hidden w-full overflow-x-auto snap-x snap-mandatory flex p-4">
                {cards.map((card, index) => (
                    <div 
                        key={index} 
                        className="snap-center flex-shrink-0 w-[220px] h-[300px] [perspective:1000px] mx-2"
                    >
                        <div className="relative w-full h-full transition-all duration-500 [transform-style:preserve-3d] hover:[transform:rotateY(180deg)]">
                            <div className="absolute w-full h-full rounded-2xl shadow-lg overflow-hidden [backface-visibility:hidden]">
                                <img 
                                    src={card.image} 
                                    alt={card.title} 
                                    className="w-full h-full object-cover"
                                />
                                <div className="absolute bottom-0 w-full bg-black bg-opacity-30 text-white p-4">
                                    <h2 className="text-lg font-bold">{card.title}</h2>
                                </div>
                            </div>
                            <div className="absolute w-full h-full rounded-2xl shadow-lg bg-black p-4 flex flex-col justify-center items-center text-center text-white [backface-visibility:hidden] [transform:rotateY(180deg)]">
                                <h2 className="text-lg font-bold mb-3">{card.title}</h2>
                                <div className="text-sm text-white">{card.description}</div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AboutUs;
